/**
 * Global error handler for unhandled promise rejections
 * Prevents network errors from showing in React error overlay
 */

export const setupGlobalErrorHandler = () => {
  const isLikelyNetworkError = (error) => {
    if (!error) return false;
    const message = String(error?.message || error || '');
    const code = String(error?.code || '');
    return (
      error?.isNetworkError ||
      error?.suppressErrorOverlay ||
      (message.includes('Network Error') && !error?.response) ||
      code === 'ERR_NETWORK' ||
      code === 'ECONNREFUSED' ||
      message.includes('Failed to fetch') ||
      (error?.isAxiosError && !error?.response)
    );
  };

  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;

    // Suppress network errors from showing in React error overlay.
    // Keep this silent to avoid flooding devtools when backend is down.
    if (isLikelyNetworkError(error)) {
      event.preventDefault();
      return;
    }
    
    // For other errors, allow default handling but log them
    // Only log if it's not a known suppressed error type
    if (!error?.suppressErrorOverlay) {
      console.error('Unhandled promise rejection:', error);
    }
  });
  
  // Handle general errors
  window.addEventListener('error', (event) => {
    // Suppress network-related errors
    if (
      isLikelyNetworkError(event?.error) ||
      event.message?.includes('Network Error') ||
      event.message?.includes('Failed to fetch') ||
      event.message?.includes('ERR_NETWORK') ||
      event.message?.includes('ECONNREFUSED')
    ) {
      event.preventDefault();
      return;
    }
  }, true); // Use capture phase to catch errors early
};

// Call this function in your index.js or App.js



